var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('div',{staticClass:"second-text"},[_vm._v(" "+_vm._s(_vm.dateTimeFormatter(new Date(_vm.value * 1000)))+" ")]):_c('div',{staticClass:"second-text"},[_vm._v("-")])
}
var staticRenderFns = []

export { render, staticRenderFns }